import type { ButtonHTMLAttributes, ReactNode } from 'react'

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline'
  children: ReactNode
  fullWidth?: boolean
}

const Button = ({ variant = 'primary', children, fullWidth, className = '', ...props }: ButtonProps) => {
  const base = 'inline-flex items-center justify-center font-bold rounded-xl transition-all duration-200 cursor-pointer disabled:opacity-50 disabled:cursor-not-allowed'

  const variants = {
    primary:
      'bg-[#1a6fad] hover:bg-[#155e94] text-white px-6 py-3 text-lg shadow-md hover:shadow-lg active:scale-95',
    secondary:
      'bg-[#e62e2e] hover:bg-[#c42626] text-white px-6 py-3 text-lg shadow-md hover:shadow-lg active:scale-95',
    outline:
      'border-2 border-[#1a6fad] text-[#1a6fad] hover:bg-[#1a6fad] hover:text-white px-6 py-3 text-lg active:scale-95',
  }

  return (
    <button
      className={`${base} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
